module.exports = __webpack_public_path__ + "fonts/Open_Sans-300-greek-ext7.f4933d6.woff2";